import { useCallback } from 'react'
import { compact } from 'lodash'
import { API_HOST_NAME } from '../constants.js'
import fetchJSON from '../../../fetchJSON.js'
import toUrlSearchParams from '../../../toUrlSearchParams.js'

const useMarketplacePackagesResources = () => {
  const url = `${API_HOST_NAME}/api/v1/marketplace/packages`

  const all = useCallback((props = {}) => {
    const { params } = props
    const queryString = toUrlSearchParams(params).toString()
    const fullUrl = compact([url, queryString]).join('?')

    return fetchJSON(fullUrl, 'GET')
  }, [url])

  const get = useCallback((id, props = {}) => {
    const { params } = props
    const queryString = toUrlSearchParams(params).toString()
    const fullUrl = compact([[url, id].join('/'), queryString]).join('?')

    return fetchJSON(fullUrl, 'GET')
  }, [url])

  return { all, get }
}

export default useMarketplacePackagesResources
